import React from 'react';
import {  useLocation } from 'react-router-dom';
import Header from '../components/Header/Header';
import styles from './Layout.module.css'

const Layout = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    return (
        <>
            {!location.pathname.includes('/resource-tracker') && <Header />}
            <div className={styles.layout}>
                <div className={styles.children}>
                    {children}
                </div>
            </div>
        </>
    );
};

export default Layout;
